import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Text } from '@topconagriculture/react-components';
import { RingWarning } from '../../../Warning/RingWarning';
import { useTranslation } from 'react-i18next';
import { useDeviationAlertsSummarySubscription } from '../hooks/useDeviationAlertsSummarySubscription';
const useStyles = makeStyles(() => ({
    container: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 20 },
    wrapper: { display: 'flex', gap: 20, alignItems: 'center' },
    capitalized: { textTransform: 'capitalize' },
}));
export const DeviationAlertDetails = ({ onCLick, widgetType }) => {
    const classes = useStyles();
    const { data } = useDeviationAlertsSummarySubscription(widgetType);
    const { t } = useTranslation();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.wrapper },
            React.createElement(RingWarning, { diameter: 50, color: "#007DC5", amount: (data === null || data === void 0 ? void 0 : data.overWeightCount) || 0, fontSize: 20, onClick: onCLick }),
            React.createElement(Text, { className: classes.capitalized }, t('widget:upper'))),
        React.createElement("div", { className: classes.wrapper },
            React.createElement(RingWarning, { diameter: 50, color: "#E46A68", amount: (data === null || data === void 0 ? void 0 : data.underWeightCount) || 0, fontSize: 20, onClick: onCLick }),
            React.createElement(Text, { className: classes.capitalized }, t('widget:lower')))));
};
//# sourceMappingURL=DeviationAlertDetails.js.map